import configuration from '@/taskpane/common/configuration'

export default function sendMessageToSidebar(messageType: string, args: any) {
  const message = {
    type: messageType,
    args: args,
  }

  // Target the sidebar frame by id — frame indexing breaks as soon as any other
  // iframe exists on the page. The frame is absent until the taskpane has rendered,
  // and every host push routes through here, so drop rather than throw.
  const sidebarFrame = document.getElementById('sidebarFrame') as HTMLIFrameElement
  if (!sidebarFrame || !sidebarFrame.contentWindow) return

  sidebarFrame.contentWindow.postMessage(message, configuration.CIRRUS_PORTAL)
}
